<div class="dialog-agent">
  <h1 mat-dialog-title>
    {{ 'GLOBAL.ACTIVATE-CERTIFICATE-TITLE' | translate }}
  </h1>
  <div mat-dialog-content>
    <form class="row mx-0 pb-3" [formGroup]="activateCertificateForm">
      <div class="col-12 pb-2">
        <p class="m-0">
          {{ 'GLOBAL.ACTIVATE-CERTIFICATE-INFO' | translate }}
        </p>
      </div>
      <div class="col-12 py-2">
        <mat-label class="w-100 d-block pb-1 h6">
          {{ 'GLOBAL.CERTIFICATE-PASSWORD' | translate }}
        </mat-label>
        <mat-form-field class="w-100">
          <input [type]="hidePassword ? 'password' : 'text'" [placeholder]="'GLOBAL.INSERT-CERTIFICATE-PASSWORD' | translate" matInput autocomplete="off" formControlName="password"/>
          <i class="rt-icon pointer fs22 mx-1" matSuffix [attr.data-selenium]="'toggle-pin'" (click)="hidePassword = !hidePassword" [ngClass]="{'rt-view': hidePassword, 'rt-hide': !hidePassword}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="isFieldInvalid(activateCertificateForm?.get('password'))">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 py-2">
        <mat-label class="w-100 d-block pb-1 h6">
          {{ 'GLOBAL.NEW-CERT-PIN' | translate }} <small class="font-italic text-secondary">({{ 'GLOBAL.OPTIONAL' | translate }})</small>
        </mat-label>
        <mat-form-field class="w-100">
          <input matInput [type]="hidePin ? 'password' : 'text'" [placeholder]="'GLOBAL.INSERT-NEW-PIN' | translate" autocomplete="off" formControlName="pin"/>
          <i class="rt-icon pointer fs22 mx-1" matSuffix [attr.data-selenium]="'toggle-pin'" (click)="hidePin = !hidePin" [ngClass]="{'rt-view': hidePin, 'rt-hide': !hidePin}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="activateCertificateForm?.get('pin').hasError('minlength')">{{ 'GLOBAL.ERRORS.MINVALUE-INVALID' | translate }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 py-2">
        <mat-label class="w-100 d-block pb-1 h6">
          {{ 'GLOBAL.REPEAT-NEW-CERT-PIN' | translate }} <small class="font-italic text-secondary">({{ 'GLOBAL.OPTIONAL' | translate }})</small>
        </mat-label>
        <mat-form-field class="w-100">
          <input matInput [type]="hidePinRepeat ? 'password' : 'text'" [placeholder]="'GLOBAL.INSERT-REPEAT-NEW-PIN' | translate" formControlName="pinRepeat"/>
          <i class="rt-icon pointer fs22 mx-1" matSuffix [attr.data-selenium]="'toggle-pin'" (click)="hidePinRepeat = !hidePinRepeat" [ngClass]="{'rt-view': hidePinRepeat, 'rt-hide': !hidePinRepeat}"></i>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="activateCertificateForm?.get('pinRepeat').hasError('minlength')">{{ 'GLOBAL.ERRORS.MINVALUE-INVALID' | translate }}</mat-hint>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div mat-dialog-actions class="w-100">
    <button mat-raised-button type="submit" color="primary" class="ms-2 float-end" [disabled]="!activateCertificateForm.valid || sendingInfo" (click)="onActivate()">
      <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingInfo"></i>
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.ACTIVATE' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" [disabled]="sendingInfo" (click)="onCancel()">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CANCEL' | translate }}</span>
    </button>
  </div>
</div>
